import React, { useState, useContext, useEffect } from 'react';
import axiosConfig from '../../../../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Box, CardHeader, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
// import CommentModalForm from './CommentModalForm/CommentModalForm';
import { StateContext, DispatchContext } from '../../../../../../context/Provider';

const CommentItem = (props) => {

  const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 345
    },
    cardHeader: {
      // paddingBottom: '35px',
      // backgroundColor: props.themeColor ? props.themeColor : "#ff5722",
      // color: '#fff'
    },
    cartTitle: {
      fontWeight: 500,
      marginBottom: 0
    },
    subHeader: {
      // color: '#fff'
    },
    moreVertIcon: {
      // color: '#fff'
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    medium: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    root1: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    input1: {
      borderRadius: '12px',
      paddingTop: '3px',
      paddingBottom: '3px',
      paddingLeft: '15px',
      background: "rgb(0, 0, 0, 0.05)",
      border: '2px',
      marginLeft: theme.spacing(1),
      flex: 1
    },
    iconButton1: {
      padding: 10,
      "&:hover": {
          backgroundColor: "#fff"
      }
    },
    divider1: {
      height: 28,
      margin: 4,
    }
  }));

  const classes = useStyles();
  
  return (
    <Box>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Avatar aria-label="recipe" className={classes.medium} src={props.comment.avatar}>D</Avatar>
        }
        // action={}
        title={
          <Typography className={classes.cartTitle} gutterBottom variant="body1" component="h2">
            {props.comment.author}
          </Typography>
        }
        subheader={
          <Typography className={classes.subHeader} variant="body2" color="textSecondary" component="p">
            {props.comment.formatted_created_at}
          </Typography>
        }
      />

      <Box px={2}>
        <Typography className={classes.subHeader} variant="body2" color="textSecondary" component="p">
          {props.comment.comment}
        </Typography>
      </Box>

    </Box>
  )
}

export default CommentItem;